export const ADD_TODO = 'ADD_TODO';
export const TOGGLE_TODO = 'TOGGLE_TODO';
export const RESET_APP = 'RESET_APP';
export const REMOVE_TODO = 'REMOVE_TODO';
export const RECYCLE_PROGRESS = 'RECYCLE_PROGRESS';
export const TOGGLE_COUNTDOWN = 'TOGGLE_COUNTDOWN';
